import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'app-filter-custom-popover',
    templateUrl: './filter-popover.component.html',
    styleUrls: ['./filter-popover.component.css'],
    standalone: false
})
export class FilterPopoverCustomComponent {

  @Input() formGroup!: FormGroup;
  @Input() fields!: FormlyFieldConfig[];
  @Input() model!: any;

  @Output() submitFilter = new EventEmitter<void>();
  @Output() resetFilter = new EventEmitter<void>();
  @Output() preset = new EventEmitter<void>();

  ngOnInit(){
    this.preset.emit();
  }

  onSubmit() {
    this.submitFilter.emit();
  }

  onReset() {
    this.resetFilter.emit();
  }

}
